import {ChevronDownIcon, ChevronRightIcon} from '@primer/octicons-react'
import {IconButton, type IconButtonProps} from '@primer/react'

import styles from './group-header-expansion-button.module.css'

export function GroupHeaderExpansionButton({
  onCollapseToggle,
  isCollapsed,
  expandCollapseLabel,
  ...rest
}: {
  onCollapseToggle: () => void
  isCollapsed: boolean
  expandCollapseLabel: string
} & Partial<Omit<IconButtonProps, 'aria-labelledby'>>) {
  return (
    <IconButton
      variant="invisible"
      size="small"
      onClick={onCollapseToggle}
      icon={isCollapsed ? ChevronRightIcon : ChevronDownIcon}
      {...rest}
      aria-label={expandCollapseLabel}
      className={styles.IconButton}
    />
  )
}
